import React, { memo } from 'react';
import './Styles.css';
import { DropdownSelect, DropdownSelectSize } from '@ids/react-dropdown-select';

const Select = ({ cssClasses, defaultValue, options, onChange, label, isMandatory = false }) => {
  return (
    <div>
      <label className="if dropdown-select-label">{label}</label>
      <DropdownSelect
        invalid={isMandatory && !defaultValue?.trim()}
        inputSize={DropdownSelectSize.SMALL}
        value={defaultValue}
        onChange={onChange}
        className={cssClasses}>
        {options.map(option => (
          <option key={option.key} value={option.value}>
            {option.displayName}
          </option>
        ))}
      </DropdownSelect>
    </div>
  );
};

export default memo(Select);
